// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SW7f","right":"Footer_right__2azpx","buttons":"Footer_buttons__1rrYa"};